import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const PaymentsContainer = WithErrorBoundary(
    'Pagos',
    'Error en Pagos',
    React.lazy(()=>import('./PaymentsContainer'))
)

export default {
    path:'/pagos',
    name:'Pagos',
    childRoutes: [
        {
          path: '',
          name: 'Pagos',
          component: PaymentsContainer,
          isIndex: true
        },
      ]
}